import authRequest from "@/api/http/authRequest";

interface KakaoClipboardMessagePayload {
  id?: number;
  title: string;
  contents: string;
  messageType: string;
}

export default {
  list(cb: (response) => void, errCb: (response) => void) {
    authRequest.get("/admin/kakao-clipboard-messages", {}, cb, errCb)
  },
  create(params: KakaoClipboardMessagePayload, cb: (response) => void, errCb: (response) => void) {
    authRequest.post("/admin/kakao-clipboard-messages", params, cb, errCb)
  },
  update(params: KakaoClipboardMessagePayload, cb: (response) => void, errCb: (response) => void) {
    authRequest.patch(`/admin/kakao-clipboard-messages/${params.id}`, params, cb, errCb)
  },
  reorder(messageIds: number[], cb: (response) => void, errCb: (response) => void) {
    authRequest.patch("/admin/kakao-clipboard-messages/order", {messageIds}, cb, errCb)
  },
  listTypeOrders(cb: (response) => void, errCb: (response) => void) {
    authRequest.get("/admin/kakao-clipboard-messages/type-orders", {}, cb, errCb)
  },
  reorderTypes(messageTypes: string[], cb: (response) => void, errCb: (response) => void) {
    authRequest.patch("/admin/kakao-clipboard-messages/type-orders/order", {messageTypes}, cb, errCb)
  },
  delete(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.delete(`/admin/kakao-clipboard-messages/${id}`, cb, errCb)
  },
}
